// src/components/common/ErrorDisplay.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { ThemeContext } from '../../context/ThemeContext';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 2rem;
  text-align: center;
`;

const ErrorIcon = styled.div`
  font-size: 4rem;
  color: ${props => props.theme.error};
  margin-bottom: 1.5rem;
`;

const ErrorTitle = styled.h2`
  font-size: 1.8rem;
  color: ${props => props.theme.text};
  margin-bottom: 1rem;
`;

const ErrorMessage = styled.p`
  font-size: 1.1rem;
  color: ${props => props.theme.text};
  opacity: 0.8;
  max-width: 600px;
  margin: 0 auto 2rem;
`;

const BackButton = styled(Link)`
  display: inline-block;
  padding: 0.8rem 1.5rem;
  background-color: ${props => props.theme.primary};
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${props => props.theme.primaryDark};
    transform: translateY(-2px);
  }
  
  i {
    margin-right: 0.5rem;
  }
`;

const ErrorDisplay = ({ error, backLink = "/", backLinkText = "Retour à l'accueil" }) => {
  const { theme } = useContext(ThemeContext);
  
  return (
    <ErrorContainer>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <ErrorIcon theme={theme}>
          <i className="fas fa-exclamation-circle"></i>
        </ErrorIcon>
        <ErrorTitle theme={theme}>Une erreur s'est produite</ErrorTitle>
        <ErrorMessage theme={theme}>{error}</ErrorMessage>
        <BackButton to={backLink} theme={theme}>
          <i className="fas fa-arrow-left"></i> {backLinkText}
        </BackButton>
      </motion.div>
    </ErrorContainer>
  );
};

export default ErrorDisplay;